module.exports = "<app-topmenu-nav-search\n   [navGraph1]=true\n   [showNavSearch]=\"(showNavSearch$ | async)\">\n</app-topmenu-nav-search>\n"


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/nav/compc/topmenu-nav-search-cont/topmenu-nav-search-cont.component.html
// module id = ../../../../../src/app/nav/compc/topmenu-nav-search-cont/topmenu-nav-search-cont.component.html
// module chunks = main